import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";
import { useMutation, useQuery } from "react-query";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useEffect } from "react";

function PromptNoneConsent({ consentId, loggedIn }) {
  const axiosPrivate = useAxiosPrivate();

  // Mutations declared before the query so the query fn can reference rejectMutate.
  const {
    mutate,
    isLoading: approvalLoading,
    data: approvalData,
  } = useMutation(() => {
    return axiosPrivate.post(
      "/oauth/approveConsent",
      { consent_id: consentId },
      { withCredentials: true }
    );
  });

  const {
    mutate: rejectMutate,
    isLoading: rejectLoading,
    data: rejectData,
  } = useMutation(() => {
    return axiosPrivate.post(
      "/oauth/rejectConsent",
      { consent_id: consentId, failure_reason: "Login is required!" },
      { withCredentials: true }
    );
  });

  const { isLoading, data } = useQuery(
    ["promt_none_consent"],
    () => {
      return loggedIn
        ? axiosPrivate.get(`/oauth/consent/${consentId}`)
        : rejectMutate();
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
    }
  );

  // USEEFFECT
  useEffect(() => {
    if (data?.data?.data?.approved) {
      mutate();
    }
    if ((data && !data?.data?.data?.approved) || !loggedIn) {
      rejectMutate();
    }
  }, [data, loggedIn, mutate, rejectMutate]);

  useEffect(() => {
    if (approvalData?.data?.data?.location) {
      window.location.href = approvalData?.data?.data?.location;
    }
  }, [approvalData?.data?.data?.location]);

  useEffect(() => {
    if (rejectData?.data?.data?.location) {
      window.location.href = rejectData?.data?.data?.location;
    }
  }, [rejectData?.data?.data?.location]);

  // RENDER — silent (prompt=none) flow, just a loading indicator.
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      {(isLoading || approvalLoading || rejectLoading) && (
        <CircularProgress size={40} sx={{ color: "secondary.main" }} />
      )}
    </Box>
  );
}
export default PromptNoneConsent;
